<script>
  import viewport from '@/js/utils/useViewportAction.js';

  export let facts;
  let grow = false;
</script>

<div
  class="portfolio-facts container"
  class:grow
  use:viewport
  on:enterViewport={() => (grow = true)}
>
  {#each facts as oneFact}
    <div class="portfolio-facts__item">
      <i class="isax isax-arrow-down-1 portfolio-facts__icon" />
      <h6 class="portfolio-facts__title">{oneFact.title}</h6>
      {#if oneFact.link}
        <a href={oneFact.link} target="_blank">
          <p class="portfolio-facts__text text-micro">{oneFact.text}</p>
        </a>
      {:else}
        <p class="portfolio-facts__text text-micro">{oneFact.text}</p>
      {/if}
    </div>
    <div
      class="line-vertical"
      class:grow
      use:viewport
      on:enterViewport={() => (grow = true)}
    />
  {/each}
</div>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes grow {
    0% {
      height: 0%;
      top: 50%;
    }

    90% {
      height: 110%;
      top: -5%;
    }

    100% {
      height: 100%;
      top: 0%;
    }
  }
  .portfolio-facts {
    display: flex;
    margin-top: 5rem;
    flex-wrap: nowrap;
    justify-content: center;
    row-gap: 2rem;

    @include resp-max('s') {
      margin-top: 3rem;
    }

    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }

    @include resp-max('l') {
      flex-wrap: wrap;
    }

    &__item {
      text-align: center;
      padding: 3rem 6rem;

      @include resp-min('l') {
        width: 30rem;
      }

      @include resp-max('l') {
        padding: 0 6rem;
        width: 50%;
      }

      @include resp-max('m') {
        padding: 0 1rem;
      }
    }

    & i.portfolio-facts__icon {
      font-weight: 800;
      background: linear-gradient(90deg, #24fff2 0%, #04a4d7 100%);
      -webkit-background-clip: text;
      -moz-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    &__title {
      color: var(--royal);
      margin: 1rem auto 0;
    }

    &__text {
      color: var(--royal-light);
      max-width: 100%;
      margin: 0 auto;
    }

    .line-vertical {
      height: 100%;
      &.grow {
        animation: grow ease-in-out 1s;
      }

      @include resp-max('l') {
        display: none;
      }
      &:last-child {
        display: none;
      }
    }
  }
</style>
